"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseDateModeHelper = exports.isDateFilterRangeValue = exports.getDateEmptyFilterValue = void 0;
const date_fns_1 = require("date-fns");
const date_1 = require("../utils/date");
function getDateEmptyFilterValue(dateMode, label) {
    return {
        date_mode: dateMode,
        label,
        date_mode_value: null,
    };
}
exports.getDateEmptyFilterValue = getDateEmptyFilterValue;
function isDateFilterRangeValue(value) {
    return value.date_mode === "date_range";
}
exports.isDateFilterRangeValue = isDateFilterRangeValue;
class BaseDateModeHelper {
    constructor(comparison, dateMode, dateModeValue, userPreferences) {
        this.defaultBounds = "[]";
        this.currentDate = () => {
            return (0, date_1.getNow)(this.timeZone);
        };
        this.today = () => {
            const currentDate = this.currentDate();
            if (["is", "is_not"].includes(this.comparison)) {
                return {
                    lower: (0, date_fns_1.startOfDay)(currentDate),
                    upper: (0, date_fns_1.endOfDay)(currentDate),
                    bounds: this.bounds,
                };
            }
            return currentDate;
        };
        this.tomorrow = () => {
            const currentDate = this.currentDate();
            if (["is", "is_not"].includes(this.comparison)) {
                return {
                    lower: (0, date_fns_1.addDays)((0, date_fns_1.startOfDay)(currentDate), 1),
                    upper: (0, date_fns_1.addDays)((0, date_fns_1.endOfDay)(currentDate), 1),
                    bounds: this.bounds,
                };
            }
            return (0, date_fns_1.addDays)((0, date_fns_1.endOfDay)(currentDate), 1);
        };
        this.yesterday = () => {
            const currentDate = this.currentDate();
            if (["is", "is_not"].includes(this.comparison)) {
                return {
                    lower: (0, date_fns_1.subDays)((0, date_fns_1.startOfDay)(currentDate), 1),
                    upper: (0, date_fns_1.subDays)((0, date_fns_1.endOfDay)(currentDate), 1),
                    bounds: this.bounds,
                };
            }
            return (0, date_fns_1.subDays)((0, date_fns_1.startOfDay)(currentDate), 1);
        };
        this.one_week_from_now = () => {
            return (0, date_fns_1.addWeeks)(this.currentDate(), 1);
        };
        this.one_week_ago = () => {
            return (0, date_fns_1.subWeeks)(this.currentDate(), 1);
        };
        this.one_month_ago = () => {
            return (0, date_fns_1.subMonths)(this.currentDate(), 1);
        };
        this.one_month_from_now = () => {
            return (0, date_fns_1.addMonths)(this.currentDate(), 1);
        };
        this.one_year_ago = () => {
            return (0, date_fns_1.subYears)(this.currentDate(), 1);
        };
        this.one_year_from_now = () => {
            return (0, date_fns_1.addYears)(this.currentDate(), 1);
        };
        this.past_week = () => {
            const currentDate = this.currentDate();
            return {
                lower: (0, date_fns_1.startOfDay)((0, date_fns_1.subWeeks)(currentDate, 1)),
                upper: (0, date_fns_1.endOfDay)(currentDate),
                bounds: this.bounds,
            };
        };
        this.past_month = () => {
            const currentDate = this.currentDate();
            return {
                lower: (0, date_fns_1.startOfDay)((0, date_fns_1.subMonths)(currentDate, 1)),
                upper: (0, date_fns_1.endOfDay)(currentDate),
                bounds: this.bounds,
            };
        };
        this.past_year = () => {
            const currentDate = this.currentDate();
            return {
                lower: (0, date_fns_1.startOfDay)((0, date_fns_1.subYears)(currentDate, 1)),
                upper: (0, date_fns_1.endOfDay)(currentDate),
                bounds: this.bounds,
            };
        };
        this.next_week = () => {
            const currentDate = this.currentDate();
            return {
                lower: (0, date_fns_1.startOfDay)(currentDate),
                upper: (0, date_fns_1.endOfDay)((0, date_fns_1.addWeeks)(currentDate, 1)),
                bounds: this.bounds,
            };
        };
        this.next_month = () => {
            const currentDate = this.currentDate();
            return {
                lower: (0, date_fns_1.startOfDay)(currentDate),
                upper: (0, date_fns_1.endOfDay)((0, date_fns_1.addMonths)(currentDate, 1)),
                bounds: this.bounds,
            };
        };
        this.next_year = () => {
            const currentDate = this.currentDate();
            return {
                lower: (0, date_fns_1.startOfDay)(currentDate),
                upper: (0, date_fns_1.endOfDay)((0, date_fns_1.addYears)(currentDate, 1)),
                bounds: this.bounds,
            };
        };
        this.next_number_of_days = () => {
            if (this.dateModeValue === "0") {
                return { lower: null, upper: null, bounds: this.bounds };
            }
            const currentDate = this.currentDate();
            const lower = (0, date_fns_1.startOfDay)(currentDate);
            const upper = (0, date_fns_1.endOfDay)((0, date_fns_1.addDays)(currentDate, +this.dateModeValue));
            return {
                lower,
                upper,
                bounds: this.bounds,
            };
        };
        this.past_number_of_days = () => {
            if (this.dateModeValue === "0") {
                return { lower: null, upper: null, bounds: this.bounds };
            }
            const currentDate = this.currentDate();
            const lower = (0, date_fns_1.startOfDay)((0, date_fns_1.subDays)(currentDate, +this.dateModeValue));
            const upper = (0, date_fns_1.endOfDay)(currentDate);
            return {
                lower,
                upper,
                bounds: this.bounds,
            };
        };
        this.date_range = () => {
            var _a;
            const dateModeValue = ((_a = this.dateModeValue) !== null && _a !== void 0 ? _a : {
                lower: "",
                upper: "",
                bounds: this.bounds,
            });
            return {
                lower: (0, date_fns_1.startOfDay)((0, date_1.changeTimezone)(new Date(dateModeValue.lower), "UTC")),
                upper: (0, date_fns_1.endOfDay)((0, date_1.changeTimezone)(new Date(dateModeValue.upper), "UTC")),
                bounds: this.bounds,
            };
        };
        this.exact_date = () => {
            return (0, date_1.changeTimezone)(new Date(this.dateModeValue), "UTC");
        };
        this.comparison = comparison;
        this.dateMode = dateMode;
        this.dateModeValue = dateModeValue;
        this.userPreferences = userPreferences;
        this.timeZone = userPreferences.timezone.value;
    }
    getValue(dateMode) {
        switch (dateMode) {
            case "today":
                return this.today();
            case "tomorrow":
                return this.tomorrow();
            case "yesterday":
                return this.yesterday();
            case "one_week_from_now":
                return this.one_week_from_now();
            case "one_week_ago":
                return this.one_week_ago();
            case "one_month_ago":
                return this.one_month_ago();
            case "one_month_from_now":
                return this.one_month_from_now();
            case "one_year_ago":
                return this.one_year_ago();
            case "one_year_from_now":
                return this.one_year_from_now();
            case "past_week":
                return this.past_week();
            case "past_month":
                return this.past_month();
            case "past_year":
                return this.past_year();
            case "next_week":
                return this.next_week();
            case "next_month":
                return this.next_month();
            case "next_year":
                return this.next_year();
            case "next_number_of_days":
                return this.next_number_of_days();
            case "past_number_of_days":
                return this.past_number_of_days();
            case "date_range":
                return this.date_range();
            case "exact_date":
                return this.exact_date();
            default:
                return this.exact_date();
        }
    }
    get bounds() {
        var _a;
        return (((_a = this.dateModeValue) === null || _a === void 0 ? void 0 : _a.bounds) ||
            this.defaultBounds);
    }
}
exports.BaseDateModeHelper = BaseDateModeHelper;
